import React, { useEffect, useState } from 'react'
import Typed from 'react-typed'
import SearchFilters from './SearchFilters'
import request from '../../../service/request'
import { useSelector } from 'react-redux'
import { Helmet, HelmetProvider } from 'react-helmet-async';


const Hero = () => {
    const menu = useSelector(store => store.commonPageData.menu.length > 0 ? store.commonPageData.menu : store.commonPageData.menu)

    const [propertyTypes, setPropertyTypes] = useState([]);
    const [settings, setSetting] = useState([]);
    const [bannerImage, setBannerImage] = useState('');
    const [pageData, setPageData] = useState([]);
    const [pageNotExist, setPageNotExist] = useState(false);
    const pageslug = '/';


    useEffect(() => {
        getPageData();
    }, []);

    const getPageData = () => {
        request({
            method: 'post',
            url: 'pages/get-page-by-slug',
            headers: { "Content-Type": "application/json", "Accept": "application/json" },
            data: { 'slug': pageslug }
        })
            .then((response) => {
                setPageData(response.data);
            })
            .catch(({ data }) => {
                setPageNotExist(true);
            });
    }

    useEffect(() => {
        request({
            method: 'get',
            url: '/get-property-types'
        }).then((response) => {
            setPropertyTypes(response.data.data.property_types);
        });
    }, []);

    useEffect(() => {
        if (menu && menu.code == 0) {
            setSetting(menu.data.site_setting);
        }
    }, [menu]);

    useEffect(() => {
        setBannerImage((settings?.banner_image) ? settings.banner_image : '');
    }, [settings])

    return (
        <>
            <div>
                <HelmetProvider>
                    <Helmet>
                        <title>{(pageData && pageData?.data && Object.keys(pageData?.data).length > 0) ? pageData?.data.meta_title : "Real Estate"}</title>
                        <meta name="description" content={pageData && pageData?.data && Object.keys(pageData?.data).length > 0 && pageData?.data.meta_description} />
                        {
                            pageData?.data &&
                            <script type="application/ld+json">
                                {JSON.stringify({
                                    "@context": "https://schema.org/",
                                    "@type": "Website",
                                    "name": pageData?.data.meta_title,
                                    "description": pageData?.data.meta_description,
                                })}
                            </script>
                        }
                    </Helmet>
                </HelmetProvider>
            </div>
            <section id="hero-area" className="parallax-searchs home15 overlay thome-6 thome-1" style={(bannerImage) ? {
                background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3))`,
                backgroundImage: `url('${bannerImage}')`,
                backgroundImage: `-webkit-image-set(url('${bannerImage}') 1x, url('${bannerImage}') 2x)`,
                backgroundImage: `image-set(url('${bannerImage}') 1x, url('${bannerImage}') 2x)`,
                backgroundRepeat: 'no-repeat',
                backgroundPosition: "center top"
            } : {}}
                data-stellar-background-ratio="0.5">
                <div className="hero-main">
                    <div className="container" data-aos="zoom-in">
                        <div className="row">
                            <div className="col-12">
                                <div className="hero-inner">
                                    {/* <!-- Welcome Text --> */}
                                    <div className="welcome-text">
                                        <h1 className="h1">Find Your Dream
                                            <br className="d-md-none" />
                                            <span className="ml-2 typed border-bottom">
                                                <Typed
                                                    strings={propertyTypes && propertyTypes.length > 0 ? propertyTypes : [
                                                        'House&nbsp;', 'Apartment&nbsp;', 'Plaza&nbsp;']}
                                                    typeSpeed={60}
                                                    backSpeed={30}
                                                    backDelay={3000}
                                                    showCursor={true}
                                                    cursorChar={'|'}
                                                    loop >
                                                </Typed>
                                            </span>
                                            Property
                                        </h1>
                                        <p className="mt-4"></p>
                                    </div>
                                    {/* <!--/ End Welcome Text --> */}
                                    {/* <!-- Search Form --> */}
                                    <SearchFilters />
                                    {/* <!--/ End Search Form --> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Hero
